<div data-testid="hr-tool-overview">
  @if (toolTiles().length === 0) {
    <app-no-data />
  } @else {
    <div class="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
      @for (tile of toolTiles(); track tile.id) {
        <button
          type="button"
          class="hr-provider-tile card relative aspect-square bg-second-level"
          (click)="openTool(tile)"
          [attr.data-testid]="'hr-tool-tile-' + tile.id"
        >
          <span class="absolute left-2 top-2 text-muted-color">
            <i
              [class]="applicationTypeIcon(tile.applicationType)"
              [title]="applicationTypeLabel(tile.applicationType)"
            ></i>
          </span>

          <span class="absolute right-2 top-2 text-muted-color">
            <i class="pi pi-arrow-up-right"></i>
          </span>

          <span class="flex h-full items-center justify-center p-4 pb-10 pt-7">
            @if (showLogo(tile)) {
              <img
                [src]="tile.logoUrl"
                [alt]="tile.name"
                class="max-h-[55%] max-w-[60%] object-contain"
                (error)="onLogoError(tile)"
              />
            } @else {
              <span class="text-center text-sm font-semibold text-muted-color">
                {{ tile.name }}
              </span>
            }
          </span>

          <span
            class="hr-provider-tile__label absolute bottom-0 left-0 right-0 px-3 py-2 text-center"
          >
            <span class="block truncate text-xs font-semibold">{{ tile.name }}</span>
            <span class="text-green block truncate text-[11px] font-normal">
              {{ tile.providerName }}
            </span>
          </span>
        </button>
      }
    </div>
  }
</div>
